import script from "./familiaFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./familiaFilter.vue?vue&type=script&setup=true&lang=js"

import "./familiaFilter.vue?vue&type=style&index=0&id=bb5c2b00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb5c2b00"]])

export default __exports__